if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}

Shopify.theme.jsAjaxCart = {
  init: function () {
    this.loadCartContents();
    let openButton = document.querySelector('[data-ajax-cart-trigger]');
    let closeButton = document.querySelector('[data-ajax-cart-close]');
    let ajaxCartOverlay = document.querySelector('[data-ajax-cart-overlay]');
    openButton.addEventListener('click', event => {
      this.onCartOpen();
    });
    closeButton.addEventListener('click', event => {
      this.onCartClose();
    });
    ajaxCartOverlay.addEventListener('click', event => {
      this.onCartClose();
    });
    this.submitCart();
  },
  addCartEvents: function () {
    var event = new Event('change');

    function updateInputQuantity() {
      let wrapper = this.closest('[data-cart-item-quantity-wrapper]'),
          input = wrapper.querySelector('[data-cart-item-quantity]'),
          minus = wrapper.querySelector('[data-cart-item-quantity-minus]'),
          plus = wrapper.querySelector('[data-cart-item-quantity-plus]'),
          count,
          valMax = input.getAttribute('max'),
          valMin = input.getAttribute('min');

      if (this === minus) {
        count = parseInt(input.value) - 1;
      } else {
        count = parseInt(input.value) + 1;
      }

      if (count > valMax) {
        input.value = valMax;
        plus.disabled = true;
        minus.disabled = false;
        input.dispatchEvent(event);
      } else if (count < valMin) {
        input.value = valMin;
        minus.disabled = true;
        plus.disabled = false;
        input.dispatchEvent(event);
      } else {
        minus.disabled = false;
        plus.disabled = false;
        input.value = count;
        input.dispatchEvent(event);
      }

      return false;
    }

    [...document.querySelectorAll('[data-cart-item-quantity-minus]')].forEach(minus => {
      minus.addEventListener('click', updateInputQuantity);
    });
    [...document.querySelectorAll('[data-cart-item-quantity-plus]')].forEach(plus => {
      plus.addEventListener('click', updateInputQuantity);
    });
    [...document.querySelectorAll('[data-cart-item-quantity]')].forEach(qty => {
      qty.addEventListener('change', this.changeQty);
    });
    [...document.querySelectorAll('[data-cart-item-remove]')].forEach(button => {
      button.addEventListener('click', this.removeLineItem);
    });
  },
  changeQty: event => {
    var item = event.currentTarget,
        params = JSON.stringify({
      line: item.dataset.cartItemIndex,
      quantity: item.value
    });
    var http = new XMLHttpRequest();
    var url = '/cart/change.js';
    http.open('POST', url, true);
    http.setRequestHeader('Content-type', 'application/json');

    http.onreadystatechange = function () {
      if (http.readyState == 4 && http.status == 200) {
        let data = JSON.parse(http.responseText);
        let cartSelector = '[data-cart-item-quantity][data-cart-item-index="' + item.dataset.cartItemIndex + '"]';
        [...document.querySelectorAll(cartSelector)].forEach(qty => {
          qty.value = item.value;

          if (qty.hasAttribute('data-max-hd')) {
            if (qty.dataset.maxHd > 0) {
              const noHdMsg = qty.closest('[data-cart-item]').querySelector('[data-no-hd]');

              if (+qty.value <= +qty.dataset.maxHd) {
                if (noHdMsg) {
                  noHdMsg.textContent = '';
                }
              } else if (+qty.value > +qty.dataset.maxHd) {
                if (noHdMsg) {
                  noHdMsg.textContent = qty.dataset.maxHd + ' available for Home Delivery';
                }
              }
            }
          }
        });
        Shopify.theme.jsAjaxCart.onCartChange(data);
      }
    };

    http.send(params);
  },
  closeCart: function () {
    document.querySelector('[data-ajax-cart]').classList.remove('is-open');
    document.querySelector('body').classList.remove('mini-cart--open');
    this.onCartClose();
  },
  loadCartContents: async function () {
    let self = this;
    var http = new XMLHttpRequest();
    var url = '/cart?view=ajax';
    http.open('GET', url, true);

    http.onreadystatechange = function () {
      if (http.readyState == 4 && http.status == 200) {
        const html = http.responseText;
        document.querySelector('[data-ajax-cart-contents]').innerHTML = html;
        self.addCartEvents();
        document.dispatchEvent(new Event('cart:updated'));

        if (window.cartCall) {
          window.cartCall();
        }
      }
    };

    http.send();
  },
  removeLineItem: event => {
    var item = event.currentTarget,
        params = JSON.stringify({
      line: item.dataset.cartItemIndex,
      quantity: 0
    });
    var http = new XMLHttpRequest();
    var url = '/cart/change.js';
    http.open('POST', url, true);
    http.setRequestHeader('Content-type', 'application/json');

    http.onreadystatechange = function () {
      if (http.readyState == 4 && http.status == 200) {
        JSON.parse(http.responseText); // animate removal of line item (ajax and page)

        let cartSelector = '[data-cart-item][data-cart-item-index="' + item.dataset.cartItemIndex + '"]';
        document.querySelectorAll(cartSelector).forEach(item => item.remove());
        document.dispatchEvent(new Event('cart:updated'));
        Shopify.theme.jsAjaxCart.onCartChange();
      }
    };

    http.send(params);
  },
  doCartChange: function (data) {
    if (data === undefined) {
      this.loadCartContents();
    } else {
      // Update line item subtotals
      // ...
      // Update cart total
      document.querySelectorAll('[data-cart-total]').forEach(total => total.innerText = Utils.formatMoney(data.total_price / 100));
    }

    if (typeof Shopify.theme.jsCartCounter !== 'undefined') {
      Shopify.theme.jsCartCounter.update();
    }
  },
  onCartChange: function (data) {
    this.doCartChange(data);
    document.dispatchEvent(new CustomEvent('cart:updated'));
  },
  onCartClose: function () {
    if (Shopify.theme.settings.cart_action == 'ajaxcart') {
      document.querySelector('[data-ajax-cart]').classList.remove('is-open');
      document.querySelector('body').classList.remove('mini-cart--open');

      if (document.querySelector('#add_to_cart')) {
        document.querySelector('#add_to_cart').removeAttribute('disabled');
      }
    }
  },
  onCartOpen: function () {
    if (Shopify.theme.settings.cart_action == 'ajaxcart') {
      document.querySelector('[data-ajax-cart]').classList.add('is-open');
      document.querySelector('body').classList.add('mini-cart--open');
    }
  },
  openCart: function () {
    document.querySelector('[data-ajax-cart] button').click();
    this.onCartOpen();
  },
  submitCart: function () {
    const form = document.querySelector('main form[action="/cart"]');
    if (!form) return false;
    form.addEventListener('submit', e => {
      localStorage.removeItem('__ui');
    });
  }
};

(() => {
  Shopify.theme.jsAjaxCart.init();
  document.addEventListener('rebuy:cart.add', () => {
    Shopify.theme.jsAjaxCart.loadCartContents();
    Shopify.theme.jsAjaxCart.onCartOpen();
  });
})();
